import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-radio",
  "use": "icon-radio-usage",
  "viewBox": "0 0 14 14",
  "content": "<symbol viewBox=\"0 0 14 14\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-radio\">\n<rect x=\"2\" y=\"2\" width=\"10\" height=\"10\" rx=\"5\" fill=\"white\" stroke=\"#095540\" stroke-width=\"4\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol